<template>
  <b-overlay :show="loading" class="h-100">
    <b-navbar type="dark" variant="info" class="navbar">
      <b-navbar-brand>蝴蝶蘭苗株分級系統</b-navbar-brand>
      <b-collapse id="nav-text-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item @click="goToHome">
            首頁
          </b-nav-item>
          <b-nav-item v-b-modal.model-standard>
            分級標準表
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal
      id="model-standard"
      ok-only
      size="xl"
      hide-footer
      ok-title="關閉"
      :scrollable="true"
    >
      <template v-slot:modal-title>
        蝴蝶蘭苗株品質影像分級標準表
      </template>
      <StandardTable
        :maxLeafLength="maxLeafLength.string"
        :minLeafCount="minLeafCount.string"
        :largestLeafRatio="largestLeafRatio.string"
        :longSide="longSide.string"
        :aspectRatio="aspectRatio.string"
      />
    </b-modal>
    <b-alert :show="showAlert" variant="danger" fade :dismissible="true">
      <a href="#" class="alert-link">載入分級閾值錯誤，請重新載入頁面</a>
    </b-alert>
    <Home class="mt-4" />
  </b-overlay>
</template>

<script>
// component
import Home from "./views/Home.vue";
import StandardTable from "./components/StandardTable.vue";
import {
  getMaxLeafLength,
  getMinLeafCount,
  getLargestLeafRatio,
  getLongSide,
  getAspectRatio,
  setThreshold
} from "./api";

export default {
  name: "App",
  components: {
    Home,
    StandardTable
  },
  data() {
    return {
      maxLeafLength: "",
      minLeafCount: "",
      largestLeafRatio: "",
      longSide: "",
      aspectRatio: "",
      loading: true,
      showAlert: false
    };
  },
  methods: {
    goToHome() {
      history.go(-1);
    }
  },
  async created() {
    Promise.all([
      getMaxLeafLength(),
      getMinLeafCount(),
      getLargestLeafRatio(),
      getLongSide(),
      getAspectRatio()
    ])
      .then(async (values) => {
        [
          this.maxLeafLength,
          this.minLeafCount,
          this.largestLeafRatio,
          this.longSide,
          this.aspectRatio
        ] = values;
        await setThreshold(
          this.maxLeafLength.values,
          this.minLeafCount.values,
          this.largestLeafRatio.values,
          this.longSide.values,
          this.aspectRatio.values
        );
      })
      .catch(() => {
        this.showAlert = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style>
html,
body {
  min-height: 100%;
  padding: 0;
  margin: 0;
}
</style>
